export default __webpack_public_path__ + "static/media/Roadmap.98ce37aa.svg";